module.exports = __webpack_public_path__ + "static/media/ananta.8d1b8a1b.png";